import { fetchPostAPI, removeAndAddListeners } from "../general/BuddyFuncs";
import TagFilter from "./TagFilter";

export default class Agenda {
  constructor(
    params = {
      fetchUrl: "",
      agendaSelector: "",
      agendaFilterSelector: "",
      listSettings: {},
      minCharacters: 2,
      agendaTitleSelector: ".agendaHeader h3",
      agendaPrevSelector: "",
      agendaNextSelector: "",
    }
  ) {
    this.fetchUrl = params.fetchUrl;

    this.agendaSelector = params.agendaSelector;
    this.agenda = null;

    this.agendaFilterSelector = params.agendaFilterSelector;
    this.agendaFilter = null;

    this.agendaTitleSelector = params.agendaTitleSelector;
    this.agendaTitle = null;

    this.agendaPrevSelector = params.agendaPrevSelector;
    this.agendaPrev = null;

    this.agendaNextSelector = params.agendaNextSelector;
    this.agendaNext = null;

    this.month = null;

    this.listSettings = params.listSettings;

    this.minCharacters = params.minCharacters;

    this.currentDate = new Date();
    this.currentMonth = this.currentDate.getMonth() + 1;
    this.currentYear = this.currentDate.getFullYear();
    this.currentSize = "mobile";

    this.weekDays = ["MA", "DI", "WO", "DO", "VR", "ZA", "ZO"];
    this.monthNames = [
      "Jan",
      "Feb",
      "Maa",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Aug",
      "Sepr",
      "Oct",
      "Nov",
      "Dec",
    ];

    this.events = [
      /* {
        date: "21/03/2021",
        events: [
          {
            title: "tester",
            link: "#",
            icon: "",
            category: "akkerbouw",
            author: "tester",
          },
          {
            title: "tester",
            link: "#",
            icon: "",
          },
          {
            title: "tester",
            link: "#",
            icon: "",
          },
          {
            title: "tester",
            link: "#",
            icon: "",
          },
          {
            title: "tester",
            link: "#",
            icon: "",
          },
        ],
      },
      {
        date: "28/03/2021",
        events: [
          {
            title: "Titel",
            link: "#",
            icon: "",
            category: "akkerbouw",
            author: "tester",
          },
          {
            title: "tester",
            link: "#",
            icon: "",
            category: "akkerbouw",
            author: "tester",
          },
          {
            title: "tester",
            link: "#",
            icon: "",
            category: "akkerbouw",
            author: "tester",
          },
          {
            title: "tester",
            link: "#",
            icon: "",
            category: "akkerbouw",
            author: "tester",
          },
          {
            title: "tester",
            link: "#",
            icon: "",
            category: "akkerbouw",
            author: "tester",
          },
        ],
      }, */
    ];

    this.eventsMaster = this.events;

    this.eventsListHolder = null;
    this.eventsList = null;
  }

  init() {
    //set agenda
    this.agenda = document.querySelector(this.agendaSelector);

    //set update month btns
    this.agendaPrev = document.querySelector(this.agendaPrevSelector);
    this.agendaNext = document.querySelector(this.agendaNextSelector);

    //set title
    this.agendaTitle = document.querySelector(this.agendaTitleSelector);

    if (this.agenda) {
      //set month element
      this.month = this.agenda.querySelector(".month");

      //setup filter
      this.agendaFilter = new TagFilter({
        searchUrl: "",
        inputSelector: `${this.agendaFilterSelector} input`,
        resultsSelector: `${this.agendaFilterSelector} .results`,
        tagsHolderSelector: `${this.agendaFilterSelector} .tagsHolder`,
        clearSelector: `${this.agendaFilterSelector} .clear`,
        itemHolderSelector: "#month",
        listSettings: this.listSettings,
        minCharacters: this.minCharacters,
        justReturnFilters: true,
      });

      this.agendaFilter.init();

      //add window Resize Listener
      removeAndAddListeners(window, "resize", (e) => {
        this.handleResize(e);
      });

      ///listen for filter change
      removeAndAddListeners(window, "changeFilter", (e) =>
        this.handleUpdateFilters(e)
      );

      //listen for moth update
      removeAndAddListeners(this.agendaPrev, "click", (e) =>
        this.handleUpdateMonth(e, -1)
      );
      removeAndAddListeners(this.agendaNext, "click", (e) =>
        this.handleUpdateMonth(e, 1)
      );

      //TESTING use fetch in master
      this.updateMonth();
    }
  }

  handleUpdateMonth(e, dir) {
    e.preventDefault();

    this.updateMonth(dir);
  }

  updateMonth(dir = 0) {
    //set new values on top
    this.setNewMonth(dir);

    //create form data
    const monthData = new FormData();

    monthData.append("month", this.currentMonth);
    monthData.append("year", this.currentYear);

    //fetch new month events
    fetchPostAPI(this.fetchUrl, monthData).then((r) => {
      //add the events to the master
      this.eventsMaster = r.events;
      this.events = this.eventsMaster;

      //filter events and update agenda
      this.handleUpdateFilters();
    });

    //this.handleUpdateFilters();
  }

  setNewMonth(dir = 0) {
    this.currentMonth += dir;

    if (this.currentMonth < 1) {
      //is last year december
      this.currentYear--;

      this.currentMonth = 12;
    }

    if (this.currentMonth > 12) {
      //is next year januari
      this.currentYear++;

      this.currentMonth = 1;
    }

    this.setMonthTitle();
  }

  setMonthTitle() {
    if (this.agendaTitle) {
      this.agendaTitle.textContent = `${
        this.monthNames[this.currentMonth - 1]
      } ${this.currentYear}`;
    }
  }

  handleUpdateFilters(e) {
    const filters = this.agendaFilter.filters;

    this.filterEvents(filters);
  }

  filterEvents(filters) {
    this.events = [];

    this.eventsMaster.forEach((day) => {
      const filteredEvents = day.events.filter((event) => {
        let hasMatch = true;

        filters.forEach((filter) => {
          if (event[filter.type] !== filter.title) {
            hasMatch = false;
          }
        });

        return hasMatch;
      });

      if (filteredEvents.length > 0) {
        this.events.push({ ...day, events: filteredEvents });
      }
    });
    this.updateAgenda();
  }

  setSize() {
    this.agenda.offsetWidth >= 600
      ? (this.currentSize = "desktop")
      : (this.currentSize = "mobile");

    return this.currentSize;
  }

  clearMonth() {
    this.month.innerHTML = "";
    this.eventsListHolder = null;
  }

  updateAgenda() {
    //clear the current elements
    this.clearMonth();

    if (this.setSize() === "mobile") {
      this.createMobileAgenda();
    } else {
      this.createDesktopAgenda();
    }
  }

  createMobileAgenda() {
    let daysHtml = "";

    //set first day preview
    daysHtml += this.events[0] ? this.createDay(
      this.calcBreakDate(this.events[0].date, false, true)
    ) : "";

    //create days
    this.events.forEach((event, index) => {
      //create the event day
      daysHtml += this.createDay(event);

      //create the next day counter if needed
      daysHtml += this.createDay(
        this.calcBreakDate(event.date, this.events[index + 1])
      );
    });

    this.setMonth(daysHtml);

    //remove eventsList
    this.removeEventsList();
  }

  dateObj(date) {
    return {
      day: parseInt(date.substring(0, 2)),
      month: parseInt(date.substring(3, 5)),
      monthName: this.monthNames[parseInt(date.substring(3, 5)) - 1],
      year: parseInt(date.substring(6, date.length)),
    };
  }

  getMonthLenght(dateObj) {
    return parseInt(this.days(dateObj.month, dateObj.year));
  }

  createDesktopAgenda() {
    let monthHtml = "";

    //create the weekday holders
    monthHtml += this.createWeekDays();

    //add the days of the month
    monthHtml += this.monthDays();

    this.setMonth(monthHtml);

    //add create eventsList
    this.createEventsList();

    //add listeners to the article days
    const dayWithEvents = this.month.querySelectorAll(
      `${this.agendaSelector} .dayWithEvents`
    );

    dayWithEvents.forEach((day) => {
      removeAndAddListeners(day, "click", (e) => this.openEventsList(e));
    });
  }

  removeEventsList() {}

  createEventsList() {
    if (this.month && this.eventsListHolder === null) {
      const agendaElm = document.querySelector(this.agendaSelector);
      const cardHolderMsg = agendaElm && agendaElm.dataset.cardholdermsg ? agendaElm.dataset.cardholdermsg : 'Events van de dag';

      //create the list
      this.eventsListHolder = document.createElement("div");

      this.eventsListHolder.classList.add("eventList");
      this.eventsListHolder.classList.add("card");

      this.eventsListHolder.innerHTML = `<header>
      <h3>${("0" + (this.currentDate.getDay())).slice(-2)}/${
        ("0" + (this.currentDate.getMonth() + 1)).slice(-2)
      }/${this.currentDate.getFullYear()}</h3>
      <p>${cardHolderMsg}</p>
      </header>`;

      this.eventsListHolder.innerHTML += `<button class="roundBtn closeIconWhite closeEventList"><span class
    ="hide">sluit</span></button>`;

      this.eventsList = document.createElement("ul");

      this.eventsList.classList.add("events");

      this.eventsListHolder.append(this.eventsList);
      
      this.month.append(this.eventsListHolder);

      //add close listener
      const closeBtn = this.eventsListHolder.querySelector(".closeEventList");

      if (closeBtn) {
        removeAndAddListeners(closeBtn, "click", (e) =>
          this.closeEventsList(e)
        );
      }
    }
  }

  closeEventsList(e) {
    e.preventDefault();
    this.eventsListHolder.classList.remove("open");
  }

  updateEventsList(date, events) {
    //set date
    const dateElem = this.eventsListHolder.querySelector("h3");
    if (dateElem) {
      dateElem.textContent = date;
    }

    //empty
    this.eventsList.innerHTML = "";

    //fill
    events.forEach((event) => {
      const clone = event.cloneNode(true);
      this.eventsList.append(clone);
    });
  }

  monthDays() {
    let monthHtml = "";
    const firstOfThemonth = new Date(this.currentMonth, this.currentYear);
    const monthLength = parseInt(
      this.days(this.currentMonth, this.currentYear)
    );
    const emptyDaysCount = firstOfThemonth.getDay() - 1;
    let weekCounter = 1;

    //create empty days
    monthHtml += `<div class="week">`;

    //add empty day in advance
    for (let i = 1; i <= emptyDaysCount; i++) {
      monthHtml += this.createDay(" ");
    }

    //create days
    for (let x = 1; x <= monthLength; x++) {
      //create day
      //check if date has a match
      let dateMatch = false;

      this.events.forEach((event) => {
        const day = parseInt(this.dateObj(event.date).day);

        if (day === x) {
          //day matches
          dateMatch = true;
          monthHtml += this.createDay(event);
        }
      });

      //add day
      if (!dateMatch) {
        //normal day
        monthHtml += this.createDay(x);
      }

      if ((weekCounter * 7) % (x + emptyDaysCount) === 0 && x !== 1) {
        weekCounter++;
        //create new week
        monthHtml += `</div><div class="week">`;
      }
    }

    //add extra day to end if needed
    const endEmtpydays = weekCounter * 7 - (monthLength + emptyDaysCount);

    for (let i = 0; i < endEmtpydays; i++) {
      monthHtml += this.createDay(" ");
    }

    monthHtml += `</div>`;

    return monthHtml;
  }

  createWeekDays() {
    let weekDaysHtml = `<ul class="weekDays">`;

    this.weekDays.forEach((day) => {
      weekDaysHtml += `<li>${day}</li>`;
    });

    weekDaysHtml += `</ul>`;

    return weekDaysHtml;
  }

  setMonth(htmlText) {
    this.month.innerHTML = htmlText;
  }

  days(month, year) {
    return new Date(year, month, 0).getDate();
  }

  calcBreakDate(date, nextDateElem, isFirst = false) {
    const currentDay = this.dateObj(date);
    let dateResult = "";

    if (!nextDateElem) {
      if (isFirst) {
        if (currentDay.day > 1) {
          const differce = currentDay.day - 1;

          //check has before days
          if (differce > 1) {
            //multiple dates
            dateResult = `1 ${currentDay.monthName} - ${currentDay.day - 1} ${
              currentDay.monthName
            }`;
          } else {
            //one date
            dateResult = `1 ${currentDay.monthName}`;
          }
        }
        //keep default if nothing
      } else {
        //is last element in the list
        const lastDate = this.getMonthLenght(currentDay);
        const differce = lastDate - currentDay.day;

        //check has before days
        if (differce > 1) {
          //multiple
          dateResult = `${currentDay.day + 1} ${
            currentDay.monthName
          } - ${lastDate} ${currentDay.monthName}`;
        } else if (differce === 1) {
          //one
          dateResult = `${currentDay.day + 1} ${currentDay.monthName}`;
        } else {
          //none
          dateResult = "";
        }
      }
    } else {
      //use next date
      const nextDate = nextDateElem.date;

      const nextDateDay = parseInt(nextDate.substring(0, 2));
      const differce = nextDateDay - currentDay.day;

      //check if days in between
      if (differce > 1) {
        //multiple
        dateResult = `${currentDay.day + 1} ${currentDay.monthName} - ${
          nextDateDay - 1
        } ${currentDay.monthName}`;
      } else if (differce === 1) {
        //one
        dateResult = `${currentDay.day + 1} ${currentDay.monthName}`;
      } else {
        //none
        dateResult = "";
      }
    }

    return dateResult;
  }

  handleResize(e) {
    const oldSize = this.currentSize;
    //detect change in size
    if (oldSize !== this.setSize()) {
      this.updateAgenda();
    }
  }

  openEventsList(e) {
    e.preventDefault();
    
    const elem = e.currentTarget;
    
    const events = [...elem.querySelectorAll(".event")];
    const date = elem.dataset.date;

    this.updateEventsList(date, events);

    this.eventsListHolder.classList.add("open");
  }

  createDay(data) {
    if (data !== "") {
      if (data.events) {
        const dateObj = this.dateObj(data.date);

        //has events
        let eventDay = `<div class="day dayWithEvents" data-date="${
          ("0" + (dateObj.day)).slice(-2)
        }/${("0" + (dateObj.month)).slice(-2)}/${dateObj.year}">
                          <header>
                              <h4>${
                                this.setSize() === "mobile"
                                  ? `${dateObj.day} ${dateObj.monthName}`
                                  : dateObj.day
                              }</h4>
                          </header>
                          <ul class="events">`;
        data.events.forEach((event) => {
          eventDay += `<li class="event">
                        <a href="${event.link}">
                            <span class="icon ${event.icon}"></span>
                            <span>${event.title}</span>
                        </a>
                    </li>`;
        });

        eventDay += `</ul></div>`;

        return eventDay;
      } else {
        if (this.setSize() === "mobile") {
          //create mobile day
          return `<div class="day"><p class="dateRange">${data}</p></div>`;
        } else {
          //create desktop day
          return `<div class="day">${data}</div>`;
        }
      }
    }
  }
}